import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slice/authSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import adminUserReducer from "./Slice/adminSlice";
import orderReducer from "../store/Slice/orderSlice";
import orderSearchReducer from "./Slice/orderSearchSlice";
import userReducer from "../store/Slice/subadminSlice";
import filterReducer from "./Slice/filterSlice";
import themeReducer from "./Slice/themeSlice";
import recycleBinReducer from "./Slice/recycleBinSlice";
import recycleRepairReducer from "./Slice/recycleBinRepairSlice";
import notificationReducer from "../store/Slice/NotificationSlice";
import taskReducer from "./Slice/taskSlice";
import repairReducer from "./Slice/repairSlice";   // ✅ ADDED
import stockReducer from "./Slice/stockSlice";     // ✅ ADDED

const persistConfig = {
  key: "root",
  storage,
  // persist stock as well so added instruments survive reload
  whitelist: ["auth", "notifications", "stock"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  adminUser: adminUserReducer,
  orders: orderReducer,
  orderSearch: orderSearchReducer,
  user: userReducer,
  filter: filterReducer,
  theme: themeReducer,
  recycleBin: recycleBinReducer,
  recycleRepair: recycleRepairReducer,
  notifications: notificationReducer,
  task: taskReducer,
  repairs: repairReducer,          // ✅ ADDED HERE
  stock: stockReducer,            // ✅ ADDED HERE

});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
